export default {
  nav: {
    main: 'Hlavní',
    ordersAndInvoices: 'Objednávky a faktury',
    drafts: 'Koncepty',
    automation: 'Automatizace',
    workspace: 'Pracovní prostor',
    templates: 'Šablony',
    delivery: 'Doručování',
    settings: 'Nastavení',
    shippingLabels: 'Přepravní štítky',
    subscriptions: 'Předplatné',
    support: 'Podpora',
    developer: 'Vývojář',
    writeReview: 'Napsat recenzi',
    supportTicket: 'Požadavek na podporu',
    welcomeTour: 'Úvodní prohlídka',
    administratorConsole: 'Administrátorská konzole',
    logout: 'Odhlásit se',
  },
  dashboard: {
    pageTitle: 'Objednávky a faktury',
    pageDescription: 'Manage your orders and invoices',
    title: 'Objednávky a faktury',
    selectedOrders: '{count} vybraných objednávek',
    completed: '% dokončeno',
    processing: 'Zpracování, prosím čekejte...',
    bulkDownload: 'Hromadné stažení',
    upgradeBulkDownload: 'Upgradujte svůj plán pro hromadné stažení',
    showFilters: 'Zobrazit filtry',
    hideFilters: 'Skrýt filtry',
    creatingInvoices: 'Vytváření faktur, prosím čekejte...',
    bulkCreateInvoices: 'Hromadné vytvoření faktur',
    cannotCreateAutopilot: 'Nelze ručně vytvářet faktury, když je režim fakturace na autopilotu.',
    exportInvoices: 'Export faktur nebo objednávek',
    capturePayments: 'Manuální zaúčtování plateb',
    filterOrders: 'Filtrovat objednávky',
    error: 'Něco se pokazilo...',
    close: 'Zavřít',
    chooseDate: 'Vyberte datum',
    chooseIssueDate: 'Vyberte datum vystavení pro vybrané faktury',
    cancel: 'Zrušit',
    createInvoices: 'Vytvořit faktury',
    storno: 'Storno',
    bulkOrderCapture: 'Hromadné zaúčtování objednávek',
  },
  search: {
    createdBetween: 'Vytvořeno mezi',
    modifiedBetween: 'Změněno mezi',
    orderNumber: 'Objednávka č.',
    invoiceNumber: 'Faktura č.',
    refundNumber: 'Dobropis č.',
    customer: 'Zákazník',
    payment: 'Platba',
    any: 'Jakákoli',
    authorized: 'Autorizováno',
    pending: 'Čeká',
    paid: 'Zaplaceno',
    partiallyPaid: 'Částečně zaplaceno',
    refunded: 'Vráceno',
    voided: 'Zrušeno',
    partiallyRefunded: 'Částečně vráceno',
    unpaid: 'Nezaplaceno',
    fulfillment: 'Plnění',
    fulfilled: 'Odesláno',
    partial: 'Částečné',
    unfulfilled: 'Neodesláno',
    loading: 'Načítání objednávek...',
    search: 'Hledat',
  },
  orderList: {
    noCustomer: 'Bez zákazníka',
    downloadOrder: 'Stáhnout objednávku',
    deleteWarning: 'Důležité! Tímto smažete všechny faktury a dobropisy vytvořené po datu:',
    includingInvoice: 'včetně vybrané faktury č.',
    pressOk: 'Stiskněte OK pro pokračování nebo Zrušit pro zrušení.',
    cannotCreateAutopilot: 'Nelze ručně vytvářet faktury, když je režim fakturace na autopilotu.',
    createInvoice: 'Vytvořit fakturu pro tuto objednávku',
    create: 'Vytvořit',
    addCreditNote: 'Přidat dobropis',
    createStorno: 'Vytvořit storno fakturu',
    refund: 'Dobropis',
    downloadInvoice: 'Stáhnout tuto fakturu',
    download: 'Stáhnout',
    default: 'Výchozí',
    downloadStorno: 'Stáhnout toto storno/dobropis',
    fulfillOrder: 'Vyřídit objednávku',
    orderNum: 'Objednávka č.',
    locPrefix: 'Prefix lokace',
    invoiceNum: 'Faktura č.',
    refundNum: 'Dobropis č.',
    customerCol: 'Zákazník',
    orderCreatedDate: 'Datum vytvoření objednávky',
    orderModifiedDate: 'Datum změny objednávky',
    delivered: 'Doručeno',
    paymentStatus: 'Stav platby',
    fulfillmentStatus: 'Stav dodání',
    totalOutstanding: 'Celková dlužná částka',
    originalPrice: 'Původní cena',
    noOrders: 'Váš obchod nemá žádné objednávky pro vybraný stav.',
    cannotCreateNoOrders: 'Nelze vytvářet faktury, když neexistují žádné objednávky.',
    createOrdersFirst: 'Vytvořte alespoň jednu objednávku a zkuste to znovu.',
    createOrders: 'Vytvořit objednávky',
    loadingOrders: 'Načítání...',
    paidManual: 'Zaplaceno - Ručně',
    paid: 'Zaplaceno',
    refunded: 'Vráceno',
    pending: 'Čeká',
    partiallyPaid: 'Částečně zaplaceno',
    partiallyRefunded: 'Částečně vráceno',
    fulfilled: 'Odesláno',
    unfulfilled: 'Neodesláno',
    deliveryPending: 'Čeká',
    deliverNow: 'Doručit nyní',
    deliveryPartial: 'Částečné',
    notDelivered: 'Nedoručeno',
    deliverAgain: 'Doručit znovu',
    deliveryDetails: 'Podrobnosti doručení',
    deliveryFailed: 'Doručení selhalo',
    sent: 'Odesláno',
    failed: 'Selhalo',
    toLabel: 'Komu',
    folderLabel: 'Složka',
    open: 'Otevřeno',
    invoice: 'Faktura',
    creditNote: 'Dobropis',
    stornoLabel: 'Storno',
    unknown: 'Neznámé',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablet klientů',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Vrátit k tomuto datu',
    add: 'Přidat',
    close: 'Zavřít',
  },
  downloadDialog: {
    downloadType: 'Stáhnout {type}...',
    selectTemplate: 'Vyberte šablonu z galerie pro export objednávek, faktur, storno faktur nebo dobropisů.',
    getMoreTemplates: 'Získat více šablon',
    createNewTemplate: 'Vytvořit novou šablonu',
    allCreatedBetween: 'Vše vytvořeno {type} mezi',
    selectedType: 'Vybrané {type}',
    and: 'a',
    status: 'Stav',
    any: 'Jakýkoli',
    open: 'Otevřeno',
    closed: 'Uzavřeno',
    cancelled: 'Zrušeno',
    paymentStatus: 'Stav platby',
    fulfillmentStatus: 'Stav dodání',
    fulfilled: 'Odesláno',
    partial: 'Částečné',
    unfulfilled: 'Neodesláno',
    authorized: 'Autorizováno',
    pending: 'Čeká',
    paid: 'Zaplaceno',
    partiallyPaid: 'Částečně zaplaceno',
    refunded: 'Vráceno',
    voided: 'Zrušeno',
    partiallyRefunded: 'Částečně vráceno',
    unpaid: 'Nezaplaceno',
    format: 'Formát',
    forLocation: 'Pro pobočku',
    advancedOptions: 'Rozšířené možnosti',
    exportHSCodes: 'Exportovat HS kódy skladu (pomalejší)',
    noteChrome: 'Poznámka: Pro optimální stahování se doporučuje Chrome a vypnutí blokátoru reklam.',
    downloadIndividually: 'Stáhnout jednotlivě',
    downloadGrouped: 'Stáhnout seskupené',
  },
  templates: {
    pageTitle: 'Šablony',
    pageDescription: 'Customize your invoice templates',
    title: 'Šablony',
    installTranslated: 'Nainstalovat přeloženou šablonu',
    installTranslatedDesc: 'Kliknutím na toto tlačítko vyberte jiný jazyk.',
    createNew: 'V případě potřeby vytvořte novou šablonu',
    createNewDesc: 'Klikněte na toto tlačítko pro vytvoření nové šablony, pokud je potřeba.',
    customize: 'Přizpůsobit šablony',
    customizeDesc: 'Klikněte na výchozí šablonu pro její přizpůsobení. Můžete změnit logo, barvy a pro pokročilejší uživatele i kód.',
    defaultTemplate: 'Faktura, storno a dobropis (Výchozí)',
    logo: 'Logo',
    colorPalette: 'Barevná paleta',
    getColorPalettes: 'Získat barevné palety',
    paperSize: 'Velikost papíru',
    format: 'Formát',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientace',
    landscape: 'Na šířku',
    portrait: 'Na výšku',
    margin: 'Okraj (cm)',
    unsavedChanges: 'Neuložené změny',
    discard: 'Zahodit',
    save: 'Uložit',
  },
  labels: {
    pageTitle: 'Přepravní štítky',
    pageDescription: 'Create and manage shipping labels',
    title: 'Přepravní štítky',
    glsRequiresPro: 'GLS přepravní štítky pro EEU vyžadují plán Professional.',
    upgradeDesc: 'Upgradujte na Professional pro vytváření a správu přepravních štítků.',
    upgradePlan: 'Upgradujte svůj plán',
    eeuGls: 'EEU GLS',
    enabled: 'Povoleno',
    country: 'Země',
    hungary: 'Maďarsko',
    slovakia: 'Slovensko',
    czech: 'Česko',
    romania: 'Rumunsko',
    slovenia: 'Slovinsko',
    croatia: 'Chorvatsko',
    senderId: 'ID odesílatele',
    username: 'Uživatelské jméno',
    password: 'Heslo',
    name: 'Jméno',
    city: 'Město',
    address: 'Adresa',
    zipCode: 'PSČ',
    contactPerson: 'Kontaktní osoba',
    phone: 'Telefon',
    email: 'E-mail',
    glsServices: 'Služby GLS',
    expressService: 'Expresní služba',
    exchangeService: 'Výměnná služba',
    smsService: 'SMS služba',
    smsText: 'Text SMS',
    preAdviceService: 'Služba PreAdvice',
    unsavedChanges: 'Neuložené změny',
    discard: 'Zahodit',
    save: 'Uložit',
  },
  billing: {
    pageTitle: 'Fakturace',
    pageDescription: 'Manage your subscription and billing',
    title: 'Fakturace',
    subscriptionFor: 'Plán předplatného pro obchod',
    currentlySubscribed: 'Momentálně máte předplacený',
    plan: 'plán',
    cancelSubscription: 'Zrušit předplatné',
    upgradePlan: 'Upgradujte svůj plán',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / měsíc',
    upgrade: 'Upgradovat',
    includesAllStarter: 'Zahrnuje všechny funkce plánu Starter, plus:',
    proFeature1: 'Globální sada pro shodu: Prefixy dle lokace a vlastní sekvenční číslování',
    proFeature2: 'Chytrá lokalizace: Automaticky přeložené e-maily a lokalizované PDF přílohy',
    proFeature3: 'Kompletní životní cyklus B2B dokumentů: Proformy, B2B nabídky a dobropisy',
    proFeature4: 'B2B účetní synchronizace: 3místná přesnost jednotek a zobrazení více měn',
    proFeature5: 'Automatické zálohy: Automatické kopírování faktur na zabezpečený FTP nebo Google Drive',
    proFeature6: 'Shopify Flow: Automatizace generování, doručení a storna faktur pomocí triggerů a akcí Flow',
    proFeature7: 'Pokročilá AI logika: Použijte lokální AI pro složité podmíněné klauzule rozvržení',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X exporty (soulad s evropskou e-fakturací)',
    proFeature9: 'EPC QR kódy pro okamžité mobilní POS platby',
    proFeature10: 'GLS přepravní štítky pro EEU',
    proFeature11: '7letá archivace pro daňové účely',
    currentlyUsing: 'Momentálně používáte náš',
    free: 'bezplatný',
    subscriptionPlan: 'plán předplatného.',
    monthlyUsage: 'Měsíční využití',
    monthlyGenerated: '{count} / 50 faktur tento měsíc',
    monthlyLimitReached: 'Měsíční limit dosažen. Upgradujte na Starter pro neomezené faktury.',
    freePlan: 'Bezplatný plán',
    freeToInstall: 'Instalace zdarma',
    freeFeature1: 'Až 50 faktur/objednávek měsíčně',
    freeFeature2: 'Přístup ke všem 31+ předdefinovaným šablonám',
    freeFeature3: 'Základní AI Copilot',
    freeFeature4: 'Standardní stahování a tisk PDF',
    freeFeature5: 'Standardní sada dokumentů (faktury, dodací listy, účtenky)',
    freeFeature6: '3měsíční bezpečná archivace faktur',
    starterPlan: 'Plán Starter',
    starterPrice: '$9.99 / měsíc',
    starterPricePerInvoice: '+ 3¢ za vytvořenou fakturu',
    subscribe: 'Předplatit',
    starterFeature1: 'Neomezené faktury a objednávky',
    starterFeature2: 'Automatické doručení PDF e-mailem',
    starterFeature3: 'Plný přístup k hybridnímu editoru a AI Copilotu',
    starterFeature4: 'Integrace Shopify POS a čárových kódů',
    starterFeature5: 'Shopify Flow: Triggery a akce pro automatizaci faktur',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X exporty (soulad s e-fakturací)',
    starterFeature7: '1letá bezpečná archivace faktur',
    proTaxOverrides: 'Vlastní přepisy daní: DPH na produkt a sazby na úrovni SKU',
    unsavedChanges: 'Neuložené změny',
    discard: 'Zahodit',
    save: 'Uložit',
  },
  autopilot: {
    pageTitle: 'Automatizace',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatizace',
    autoCreate: 'Automaticky vytvářet faktury',
    disabled: 'Vypnuto (manuální)',
    whenCreated: 'Při vytvoření objednávek',
    whenFulfilled: 'Při vyřízení objednávek',
    whenPaid: 'Při zaplacení objednávek',
    autoCreateDesc: 'Faktury budou vytvořeny k datu, kdy jsou objednávky vytvořeny, vyřízeny nebo zaplaceny.',
    autoStorno: 'Automaticky stornovat faktury',
    whenCancelled: 'Při zrušení nebo vrácení objednávek',
    autoStornoDesc: 'Storno faktury budou vytvořeny k datu, kdy jsou objednávky zrušeny nebo jsou vytvořeny dobropisy.',
    cannotAutoFree: 'Automatické vytváření faktur nelze provádět s bezplatným plánem.',
    upgradePlan: 'Upgradujte svůj plán',
    unsavedChanges: 'Neuložené změny',
    discard: 'Zahodit',
    save: 'Uložit',
  },
  delivery: {
    pageTitle: 'Doručování',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Doručování',
    settings: 'Nastavení',
    useOrderNumbers: 'Použít čísla objednávek pro soubory',
    sendIfCountry: 'Odeslat, pokud je země fakturační adresy',
    countryCodesHint: 'Uveďte všechny kódy zemí oddělené středníkem.',
    sendForTags: 'Odeslat pro zákazníky, kteří mají jeden z uvedených štítků',
    tagsHint: 'Uveďte všechny štítky oddělené středníkem.',
    emailDelivery: 'Doručení e-mailem',
    sendAsPdf: 'Odesílat faktury jako PDF přílohy zákazníkům',
    autoSend: 'Automaticky odeslat při vytvoření faktury',
    subject: 'Předmět',
    body: 'Tělo zprávy',
    xmlAttachments: 'XML přílohy',
    attachUbl: 'Přiložit UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Přiložit ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Odeslat testovací e-mail',
    sending: 'Odesílání...',
    customSmtp: 'Vlastní SMTP server',
    customSmtpDesc: 'Použijte vlastní poštovní server místo výchozího',
    enableSmtp: 'Povolit vlastní SMTP',
    smtpHost: 'SMTP Host',
    port: 'Port',
    useSsl: 'Použít SSL/TLS',
    username: 'Uživatelské jméno',
    password: 'Heslo',
    fromEmail: 'E-mail odesílatele',
    fromName: 'Jméno odesílatele',
    shopifyLiquid: 'Šablona Shopify Liquid',
    pasteInto: 'Vložte toto do vaší',
    orderConfirmation: 'šablony potvrzení objednávky',
    toAddLink: 'pro přidání odkazu ke stažení.',
    downloadInvoice: 'Stáhněte si svou fakturu',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Odesílat požadavky do ClientsTablet při vytvoření faktur',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Odesílat PDF faktury jako celní dokumenty do ShippyPro pro země mimo EU',
    ftpBackup: 'FTP / SFTP záloha',
    ftpDesc: 'Automaticky kopírovat faktury na váš server',
    enableFtp: 'Povolit automatickou FTP zálohu',
    host: 'Host',
    useSftp: 'Použít SFTP (zabezpečené)',
    destinationFolder: 'Cílová složka',
    xmlFiles: 'XML soubory',
    includeUbl: 'Zahrnout UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Zahrnout ZUGFeRD / Factur-X XML',
    testConnection: 'Otestovat připojení',
    testing: 'Testování...',
    pro: 'PRO',
    upgradeFtp: 'Upgradujte na Professional pro automatické kopírování faktur na váš FTP/SFTP server.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Automatická synchronizace faktur na váš Drive',
    connected: 'Připojeno',
    disconnect: 'Odpojit',
    notWorking: 'Nefunguje? Přejděte na',
    googlePermissions: 'Oprávnění Google',
    removeThenReconnect: 'odeberte Invoice Browse a poté se znovu připojte.',
    connectGoogleDrive: 'Připojit Google Drive',
    upgradeGoogleDrive: 'Upgradujte na Professional pro automatickou synchronizaci faktur na Google Drive.',
    unsavedChanges: 'Neuložené změny',
    discard: 'Zahodit',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Uložit',
  },
  bookkeeping: {
    pageTitle: 'Nastavení',
    pageDescription: 'Configure your invoice settings',
    title: 'Nastavení',
    owner: 'Vlastník',
    email: 'Email',
    phone: 'Telefon',
    keepDifferentNumbering: 'Udržovat odlišné číslování faktur pro každou lokaci objednávek',
    keepDifferentNumberingDisabled: 'Udržování odlišného číslování faktur pro každou lokaci objednávek není s vaším plánem k dispozici.',
    locationEmailDesc: 'Toto umožňuje odesílat e-maily a faktury přeložené na základě lokace objednávky: skladové místo, doručovací nebo fakturační adresa',
    upgradePlan: 'Upgradujte svůj plán',
    matchingCriteria: 'Kritéria přiřazení',
    locationId: 'ID lokace',
    shippingCountryCode: 'Kód země doručovací adresy',
    billingCountryCode: 'Kód země fakturační adresy',
    matchLocationDesc: 'Přiřadit lokaci na základě ID lokace objednávky, kódu země doručovací nebo fakturační adresy.',
    companyInfo: 'Informace o společnosti',
    name: 'Název',
    website: 'Webové stránky',
    registrationNumber: 'IČO',
    taxId: 'DIČ',
    addressSection: 'Adresa',
    streetName: 'Název ulice',
    streetNumber: 'Číslo popisné',
    zip: 'PSČ',
    city: 'Město',
    region: 'Kraj',
    country: 'Země',
    bankingInfo: 'Bankovní údaje',
    bankName: 'Název banky',
    swift: 'Swift',
    currency: 'Měna',
    iban: 'IBAN',
    invoicing: 'Fakturace',
    decimalPlaces: 'Desetinná místa',
    invoicesPrefix: 'Prefix faktur',
    currentInvoiceNumber: 'Aktuální číslo faktury',
    creditNotesPrefix: 'Prefix dobropisů',
    currentCreditNoteNumber: 'Aktuální číslo dobropisu',
    lastInvoiceDate: 'Datum poslední faktury',
    noInvoicesYet: 'Zatím nebyly vytvořeny žádné faktury.',
    confirmReverting: 'Potvrzení vrácení systému',
    allInvoicesAfter: 'Všechny faktury a jejich storna vystavené po',
    willBeRemoved: 'budou odstraněny. Pokračovat s vrácením systému?',
    cancel: 'Zrušit',
    revert: 'Vrátit',
    revertDesc: 'Vrácení systému smaže všechny faktury vytvořené po vybraném datu.',
    revertToDate: 'Vrátit k tomuto datu',
    reverting: 'Vracení systému, prosím čekejte...',
    useOrderNumbering: 'Použít číslování objednávek',
    showVat: 'Zobrazit DPH na fakturách',
    overrideTaxes: 'Přepsat daně',
    pricesIncludeTax: 'Ceny zahrnují daň',
    productsTaxRate: 'Sazba daně za produkty',
    shippingTaxRate: 'Sazba daně za dopravu',
    skusSeparated: 'SKU oddělené středníkem',
    skusTaxRate: 'Sazba daně za SKU',
    useOrderDates: 'Použít data vytvoření objednávek pro faktury',
    convertCurrency: 'Převést ceny na měnu, ve které zákazník platí',
    unsavedChanges: 'Neuložené změny',
    discard: 'Zahodit',
    save: 'Uložit',
  },
  drafts: {
    pageTitle: 'Koncepty',
    pageDescription: 'Manage your draft orders',
    title: 'Koncepty',
    download: 'Stáhnout',
    newDraft: 'Nový koncept',
    exporting: 'Export {status}%...',
    accessNotGranted: 'Přístup ke konceptům objednávek nebyl udělen. Prosím',
    reLogin: 'přihlaste se znovu',
    toGrantPermissions: 'pro udělení požadovaných oprávnění "Koncepty objednávek".',
    pushFailed: 'Odeslání do Shopify selhalo:',
    exportError: 'Chyba exportu:',
    confirmDelete: 'Opravdu chcete smazat tento koncept?',
    incompleteCustomer: 'Údaje o zákazníkovi jsou neúplné:',
    pushWithoutCustomer: 'Koncept bude odeslán do Shopify bez údajů o zákazníkovi. Pokračovat?',
    customerNotInShopify: 'Tento zákazník v Shopify zatím neexistuje.',
    warnings: 'Upozornění:',
    createCustomerAndPush: 'Vytvořit zákazníka v Shopify a odeslat koncept objednávky?',
    downloadTitle: 'Stáhnout koncepty',
    cancel: 'Zrušit',
  },
  draftEdit: {
    number: "Číslo",
    prefix: "Předpona",

    newDraft: 'Nový koncept',
    editDraft: 'Upravit koncept',
    viewInShopify: 'Zobrazit v Shopify',
    back: 'Zpět',
    createDraft: 'Vytvořit koncept',
    saveChanges: 'Uložit změny',
    documentType: 'Typ dokumentu',
    draftOrder: 'Koncept objednávky',
    quote: 'Nabídka',
    proforma: 'Proforma',
    manualInvoice: 'Ruční faktura',
    currency: 'Měna',
    expiryDate: 'Datum expirace',
    status: 'Stav',
    draft: 'Koncept',
    sent: 'Odesláno',
    accepted: 'Přijato',
    customer: 'Zákazník',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    email: 'E-mail',
    phone: 'Telefon',
    company: 'Společnost',
    taxId: 'DIČ',
    billingAddress: 'Fakturační adresa',
    address: 'Adresa',
    aptSuite: 'Byt/Apartmán',
    city: 'Město',
    province: 'Okres',
    countryField: 'Země',
    zip: 'PSČ',
    shippingAddress: 'Doručovací adresa',
    sameAsBilling: 'Stejná jako fakturační',
    lineItems: 'Položky',
    shipping: 'Doprava',
    shippingTitle: 'Název',
    shippingPlaceholder: 'např. Standardní doprava',
    price: 'Cena',
    note: 'Poznámka',
    notePlaceholder: 'Interní poznámka nebo zpráva zákazníkovi...',
    summary: 'Souhrn',
    subtotal: 'Mezisoučet',
    discounts: 'Slevy',
    tax: 'Daň',
    total: 'Celkem',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Zadejte adresu vašeho obchodu',
    loginWith: 'Přihlásit se přes',
    createAccount: 'Vytvořit nový účet',
    placeholder: 'nazev-vaseho-obchodu',
    shopRequired: 'Název obchodu je povinný',
    login: 'Přihlásit se',
    shopify: 'Shopify',
    terms: 'Obchodní podmínky',
    privacy: 'Zásady ochrany osobních údajů',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Líbí se vám Invoice Browse?',
    description: 'Vytvořili jste své první faktury! Pokud vám aplikace vyhovuje, rychlá recenze na Shopify App Store nám velmi pomůže.',
    reward: 'Jako poděkování vám vynulujeme měsíční počítadlo využití',
    leaveReview: 'Napsat recenzi',
    maybeLater: 'Možná později',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Vítejte v Invoice Browse',
    welcomeContent: 'Ukážu vám, jak ji můžete používat.',
    dashboardTitle: 'Přehled',
    dashboardContent: 'Obrazovka, kterou vidíte, je hlavní přehled. Zde najdete všechny objednávky a můžete je exportovat do různých typů dokumentů jako: faktury, dodací listy a další.',
    automationTitle: 'Usnadněte si život',
    automationContent: 'Povolte automatizaci pro vytváření faktur při zaplacení nebo vrácení objednávek.',
    templatesTitle: 'Přizpůsobení šablon',
    templatesContent: 'Zde můžete přeložit šablonu, přizpůsobit ji nebo vytvořit novou.',
    deliveryTitle: 'Doručování',
    deliveryContent: 'Nakonfigurujte naši aplikaci pro automatické kopírování vytvořených dokumentů na FTP, Google Drive nebo jako přílohy e-mailů.',
    settingsTitle: 'Nastavení',
    settingsContent1: 'Upravte telefonní číslo, e-mail a další pole společnosti používaná na dokumentech.',
    settingsContent2: 'Změňte počáteční číslo dokumentu nebo smažte dokumenty vytvořené po určitém datu.',
    settingsContent3: 'Přepište sazby DPH pro dopravu a produkty',
    settingsContent4: 'Změňte počet desetinných míst pro čísla',
    reviewTitle: 'Napište recenzi',
    reviewContent: 'Podpořte náš tým napsáním dobré recenze!',
    tourTitle: 'Úvodní prohlídka',
    tourContent: 'Hej, tuto prohlídku můžete znovu otevřít odtud.',
    createDocTitle: 'Vytvořte svůj první dokument',
    createDocContent: 'Klikněte na tlačítko Vytvořit pro vytvoření prvního dokumentu.',
    docNumberTitle: 'Číslo dokumentu',
    docNumberContent: 'Prvnímu dokumentu je přiděleno číslo 1. Pokud chcete začít jiným číslem, můžete to změnit v Nastavení.',
    downloadDocTitle: 'Stáhnout dokument',
    downloadDocContent: 'Klikněte na rozbalovací nabídku Stáhnout a vyberte šablonu dokumentu pro export objednávky jako PDF.',
  },
  common: {
    save: 'Uložit',
    cancel: 'Zrušit',
    close: 'Zavřít',
    discard: 'Zahodit',
    delete: 'Smazat',
    edit: 'Upravit',
    create: 'Vytvořit',
    loading: 'Načítání...',
    unsavedChanges: 'Neuložené změny',
    upgradePlan: 'Upgradujte svůj plán',
  },
  languageSelector: {
    label: 'Jazyk',
    auto: 'Automatická detekce',
  },
  draftList: {
    draftNum: 'Koncept #',
    shopifyId: 'Shopify ID',
    type: 'Typ',
    customer: 'Zákazník',
    total: 'Celkem',
    status: 'Stav',
    delivered: 'Doručeno',
    date: 'Datum',
    actions: 'Akce',
    noCustomer: 'Bez zákazníka',
    noDrafts: 'Žádné koncepty ani nabídky.',
    loading: 'Načítání...',
    download: 'Stáhnout',
    default: 'Výchozí',
    pending: 'Čekající',
    deliverNow: 'Doručit nyní',
    deliveryDetails: 'Podrobnosti doručení',
    sent: 'Odesláno',
    failed: 'Selhalo',
    deliverAgain: 'Doručit znovu',
    partial: 'Částečně',
    notDelivered: 'Nedoručeno',
    deliveryFailed: 'Doručení selhalo',
    unknown: 'Neznámý',
    edit: 'Upravit',
    send: 'Odeslat',
    pushToShopify: 'Odeslat do Shopify',
    complete: 'Dokončit',
    duplicate: 'Duplikovat',
    delete: 'Smazat',
    quote: 'Nabídka',
    proforma: 'Proforma',
    draftOrder: 'Koncept objednávky',
    manualInvoice: 'Ruční faktura',
  },
  draftSearch: {
    createdBtw: 'Vytvořeno mezi',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Zákazník',
    status: 'Stav',
    type: 'Typ',
    delivery: 'Doručení',
    any: 'Vše',
    draft: 'Koncept',
    sent: 'Odesláno',
    accepted: 'Přijato',
    expired: 'Vypršelo',
    converted: 'Převedeno',
    cancelled: 'Zrušeno',
    quote: 'Nabídka',
    proforma: 'Proforma',
    draftOrder: 'Koncept objednávky',
    manualInvoice: 'Ruční faktura',
    delivered: 'Doručeno',
    notDelivered: 'Nedoručeno',
    pending: 'Čekající',
    search: 'Hledat',
  },
  draftDownload: {
    title: 'Stáhnout Koncept #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Stav',
    documentType: 'Typ',
    any: 'Vše',
    draft: 'Koncept',
    sent: 'Odesláno',
    accepted: 'Přijato',
    expired: 'Vypršelo',
    converted: 'Převedeno',
    cancelled: 'Zrušeno',
    quote: 'Nabídka',
    proforma: 'Proforma',
    draftOrder: 'Koncept objednávky',
    manualInvoice: 'Ruční faktura',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Instalovat novou šablonu',
    tabStyle: 'Styl',
    tabContent: 'Obsah',
    tabTranslations: 'Překlady',
    tabSettings: 'Nastavení',
    tabCode: 'Kód',
    tabCopilot: 'AI Kopilot',
    logo: 'Logo',
    colorPalette: 'Barevná paleta',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/cs.js